export default __webpack_public_path__ + "static/media/newsletters.fb3c6c03.webp";